/**
 * Device statistics calculation utilities
 */

import util from '@/modules/common/services/utilService'
import { DEVICE_OK_TIME, DEVICE_WARNING_TIME, PAD_OK_TIME } from '@/modules/devices/services/deviceService'

/**
 * Classify device status based on hours passed and device type
 */
function classifyDeviceStatus(hoursPassed, deviceType) {
  const type = deviceType?.toLowerCase() || ''
  const isPad = type === 'pad9' || type === 'pad9+' || type.includes('pad')
  const isTablet = type === 'tablet'

  if (isPad) {
    return hoursPassed < PAD_OK_TIME ? 'working' : 'offline'
  } else if (isTablet) {
    if (hoursPassed < DEVICE_OK_TIME) return 'working'
    if (hoursPassed < DEVICE_WARNING_TIME) return 'warning'
    return 'offline'
  } else {
    if (hoursPassed < DEVICE_OK_TIME) return 'working'
    if (hoursPassed < DEVICE_WARNING_TIME) return 'warning'
    return 'offline'
  }
}

/**
 * Calculate all device statistics in a single pass
 */
export function calculateAllStats(devicesStatus) {
  if (!devicesStatus || !devicesStatus.length) {
    return { total: 0, working: 0, warning: 0, offline: 0 }
  }

  const stats = {
    total: devicesStatus.length,
    working: 0,
    warning: 0,
    offline: 0
  }

  for (let i = 0; i < devicesStatus.length; i++) {
    const device = devicesStatus[i]
    const lastSignalDate = device.date?.date

    if (!lastSignalDate) {
      stats.offline++
      continue
    }

    const hoursPassed = util.getHoursPassed(new Date(lastSignalDate))
    const status = classifyDeviceStatus(hoursPassed, device.device_type)
    stats[status]++
  }

  return stats
}

/**
 * Get devices by status
 */
export function getDevicesByStatus(devicesStatus, status) {
  if (!devicesStatus || !devicesStatus.length) return []

  const devices = []

  for (let i = 0; i < devicesStatus.length; i++) {
    const device = devicesStatus[i]
    const lastSignalDate = device.date?.date

    if (!lastSignalDate && status === 'offline') {
      devices.push({
        room_name: device.room_name || 'N/A',
        device_id: device.device_id || 'N/A',
        id: device.id || 'N/A'
      })
      continue
    }

    if (!lastSignalDate) continue

    const hoursPassed = util.getHoursPassed(new Date(lastSignalDate))
    const deviceStatus = classifyDeviceStatus(hoursPassed, device.device_type)

    if (deviceStatus === status) {
      devices.push({
        room_name: device.room_name || 'N/A',
        device_id: device.device_id || 'N/A',
        id: device.id || 'N/A'
      })
    }
  }

  return devices
}

